import { getStaticUrl } from "../../../utils"

export const AcademyBranches = () => {
    return (
        <div className="flex flex-row justify-center gap-2 font-bold uppercase text-center text-xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
            <a href="https://fcunitra.ru" target="_blank" className="cursor-pointer transition-all bg-white/95 rounded-xl text-sky-950 p-1 px-3 flex flex-row gap-2 items-center justify-center hover:shadow-lg w-48">
                <img src={getStaticUrl('https://academy.fcrodina.com/uploads/rodina/fdc65cf250c003dcbdf922c14b71086e.PNG')} className="h-16 object-cover" />
                <span>Родина-Юнитра</span>
            </a>
            <div className="transition-all bg-white/95 rounded-xl text-sky-950 p-1 flex flex-row gap-2 items-center justify-center hover:shadow-lg w-60">
                <img src={getStaticUrl('https://academy.fcrodina.com/uploads/rodina/logos/79f9c5b714c4b0b313b02850c4f0a369.jpg')} className="w-12" />
                <span>Родина-Сходненская</span>
            </div>
        </div>
    )
}